import { IQueryFeatureResult } from '@turnercode/feature-flag-client';
import { Queue } from '@turnercode/cdp-queue';
import { URLS, queueOptions } from './constants';
import { hasLocalStorage } from './browser';
import { sendRequest, SendRequestError } from './sendRequest';
import { Psm } from '../Psm';
import pkg from '../../package.json';

const win = window;
let logger: Queue;
let environment: string;
let values: Psm;

export interface LogOptions {
  flgs?: IQueryFeatureResult[];
  err?: Error | SendRequestError;
  methodName: string;
  eventType: string;
  wmukid?: string;
  context?: object;
  message?: string;
}

export function createLogger(psm: Psm) {
  environment = psm.config.psmEnvironment ? psm.config.psmEnvironment.toUpperCase() : 'PROD';
  values = psm;

  logger = new Queue('logger', queueOptions, (item: any, done: any) => {
    if (/bot|crawl|spider/i.test(win.navigator.userAgent)) {
      return done(null, {});
    }
    item.ts = new Date().toISOString();
    sendRequest(URLS.logs[environment], {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item),
    })
      .then((res) => done(null, res))
      .catch((err) => done(err));
  });

  logger.start();
}

export const mapFlags = (flags: IQueryFeatureResult[]) =>
  flags.reduce((acc, { flagId, enabled }) => {
    acc[flagId] = enabled;
    return acc;
  }, {});

/**
 * Not intended to be called directly. Only to be invoked by debug(), warn(), and error()
 * and only exported for testing purposes.
 */
export function log(options: LogOptions, level: string) {
  let message, stack, additionalContext;
  if (options.err) {
    message = options.err.toString();
    stack = options.err.stack;
    additionalContext = options.err['context'] || {};
  } else {
    message = options.message;
  }

  const item = {
    lvl: level,
    pf: 'web',
    ver: pkg.version,
    type: options.eventType,
    method: options.methodName,
    ses: values.session?.sessionid,
    msg: message,
    ctx: {
      // stack,
      cfg: values.config,
      flgs: mapFlags(values.getFlags()),
      wmukid: values.getWMUKID(),
      ts: new Date().toISOString(),
      ua: win.navigator.userAgent,
      dom: win.location.hostname,
      ...additionalContext,
    },
  };

  const localStorageDebugFlag = hasLocalStorage() && win.localStorage.getItem('wmpsm_debug') == 'true';
  const queryStringDebugFlag = win.location.search.includes('wmpsm_debug');

  if (localStorageDebugFlag || queryStringDebugFlag || environment === 'AUTOMATED_TEST') {
    console[level](`[PSM]: ${item.lvl}:`, item);
  } else {
    logger.addItem(item);
  }

  return item;
}

export function info(options: LogOptions) {
  return log(options, 'info');
}

export function debug(options: LogOptions) {
  return log(options, 'debug');
}

export function warn(options: LogOptions) {
  return log(options, 'warn');
}

export function error(options: LogOptions) {
  return log(options, 'error');
}
